<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Nyhed" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div>
			<form-grid-layout>
				<div v-show="active == 'details'">
					<string-view label="Overskrift" v-model="entity.title" :height="700" />
					<text-view label="Indhold" v-model="entity.content" :height="600" />
				</div>
				<div v-show="active == 'files'">
					<file-list-view v-model="entity._embedded.files" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onSendButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import merge from '../functions/merge'
	import FileListView from '../views/FileListView';

	export default {
		data: function () {
			return {
				active: 'details',
				entity: {
					title: '',
					content: '',
					_embedded: {
						files: [],
					},
				},
			};
		},
		components: {
			'TextView': TextView,
			'FileListView': FileListView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Besked'
					},
					{
						name: 'files',
						label: 'Filer'
					}
				];
			}
		},
		props: {
			submit: {
				type: Function,
				default: function () { return true; }
			},
			value: {
				type: Object,
				default: function () { return {}; }
			},
		},
		methods: {
			tabSelect(name, tabName) {
				this.active = tabName;
			},
			onSendButtonClick() {
				var r = merge({}, this.entity);

				this.submit(r);
			}
		},
		mounted() {
			console.log({
				entity: this.entity,
				value: this.value
			});

			if (this.value) {
				this.entity = merge(this.entity, this.value);
			}

			console.log({
				entity: this.entity,
				value: this.value
			});
		}
	}
</script>

<style lang="scss">
	
</style>